import urlApiV2 from '@/router/urlApiV2'
import Vue from 'vue'
import Toast from 'vue-toasted'

Vue.use(Toast)
export default {

  // CARREGAR AUTO ESCOLAS
  async loadCfc () {
    let selectCFC = [
      { value: '', text: 'SELECIONE UMA AUTO ESCOLA' },
    ]

    Vue.http.get(urlApiV2 + '/autoescola').then(response => {
      response.data.dados.map(autoescolas => {
        if (autoescolas.nome_fantasia !== '!TESTE') {
          selectCFC.push({
            value: autoescolas.tenant_schema,
            text: autoescolas.nome_fantasia,
          })
        }
      })
    })

    return selectCFC
  },

  // ALERT TOAST
  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    })
  },

}
